import { Routes, Route } from 'react-router-dom';
import SettingsLayout from './settings/SettingsLayout';
import GeneralSettings from './settings/GeneralSettings';
import SecurityPage from './settings/SecurityPage';
import BillingSettings from './settings/BillingSettings';
import NotificationSettings from './settings/NotificationSettings';
import { ChangePasswordSettings } from './settings/ChangePasswordSettings';

const SettingsPage = () => {
  return (
    <Routes>
      <Route path="/" element={<SettingsLayout />}>
        {/* <Route path="general" element={<GeneralSettings />} /> */}
        <Route path="security" element={<SecurityPage />} />
        <Route path="password" element={<ChangePasswordSettings />} />
        {/* <Route path="billing" element={<BillingSettings />} /> */}
        {/* <Route path="notifications" element={<NotificationSettings />} /> */}
        <Route index element={<SecurityPage />} />
      </Route>
    </Routes>
  );
};

export default SettingsPage;